/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
const RTSStore = dynamic(() =>
  import("../../components/UnlayerTemplates/RTSStore")
);
import { useEffect } from 'react';


export default function RTSStorePage() {
  const meta = {
    title: "Shop curated trends at Qalara wholesale marketplace ",
    description:
      "Shop curated range of ready stock that can be dispatched within 10-14 days.",
    keywords:
      "Curated, trends, values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, carving, inlay, basketry, weaving, metal, global, exports, imports, vendors, suppliers",
    url: "/explore/Ready-to-ship-store/",
  };
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload(); // Ensures the correct page loads
    };
  
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <Layout meta={meta}>
      <RTSStore />
    </Layout>
  );
}
